/**
 * Created by calhosh on 7/13/2017.
 */
import React from 'react';
import {Slider, Rail, Handles, Tracks, Ticks} from 'react-compound-slider';
import {TooltipRail, Handle, Track} from './components';
import styled from 'styled-components';
import EllipseControl from '../EllipsesControl/EllipsesControl';
import uuidv4 from 'uuid/v4';

const sliderStyle = {
	position: 'relative',
	width: '100%'
};

function ReactSliderLegend(props) {
	const {value, disabled, StyleName} = props;
	const domain = [1, value.length];

	const bodyValues = value.map(function(item) {
		return item.bodyOptionText;
	});

	return (
		<StyleSliderLegend
			mode={1}
			step={1}
			domain={domain}
			rootStyle={sliderStyle}
			disabled={disabled}
			className={StyleName}
		>
			<Rail>{(railProps) => <TooltipRail {...railProps} />}</Rail>
			<Handles>
				{({handles, activeHandleID, getHandleProps}) => (
					<div className="slider-handles">
						{handles.map((handle) => (
							<Handle
								key={handle.id}
								handle={handle}
								domain={domain}
								isActive={handle.id === activeHandleID}
								getHandleProps={getHandleProps}
							/>
						))}
					</div>
				)}
			</Handles>
			<Tracks left={false} right={false}>
				{({tracks, getTrackProps}) => (
					<div className="slider-tracks">
						{tracks.map(({id, source, target}) => (
							<Track key={id} source={source} target={target} getTrackProps={getTrackProps} />
						))}
					</div>
				)}
			</Tracks>
			<Ticks key={uuidv4()} values={bodyValues} count={value.length}>
				{({ticks}) => (
					<div className={`slider-ticks tickSliderWrapper_${ticks.length}`}>
						{ticks.map((tick, index) => (
							<TicksWrapper key={index} className="tickSliderWrapper" style={{width: `${100 / ticks.length}%`}}>
								<section className={`tickSliderLegend`} />
								<section className="tickSliderLegendValue">
									<EllipseControl
										content={tick.value}
										tooltip={tick.value}
										noOfLines={2}
										tooltipClass="tooltipCustomWidth"
									/>
								</section>
							</TicksWrapper>
						))}
					</div>
				)}
			</Ticks>
		</StyleSliderLegend>
	);
}
export default ReactSliderLegend;
const StyleSliderLegend = styled(Slider)`
	position: relative;
	width: 100%;
	top: var(--px-10);
	.slider-ticks {
		min-height: var(--px-45);
		display: flex;
		&.tickSliderWrapper_2 {
			.tickSliderWrapper {
				justify-content: space-between;
				.tickSliderLegendValue {
					min-width: var(--px-250);
				}
				&:last-child {
					.tickSliderLegend {
						margin-left: var(--px-235);
					}
					.tickSliderLegendValue {
						left: calc(var(--px-165) * -1);
					}
				}
			}
		}
		&.tickSliderWrapper_3 {
			.tickSliderWrapper {
				width: 36% !important;
				.tickSliderLegend {
					margin-left: var(--px-10);
				}
				.tickSliderLegendValue {
					min-width: var(--px-150);
					text-align: center;
				}
				&:first-child {
					width: 33% !important;
					.tickSliderLegend {
						margin-left: calc(var(--px-2) * -1);
					}
					.tickSliderLegendValue {
						min-width: var(--px-150);
						text-align: left;
					}
				}
				&:last-child {
					width: 30% !important;
					margin-right: 0;
					.tickSliderLegend {
						margin-left: var(--px-210);
					}
					.tickSliderLegendValue {
						left: calc(var(--px-70) * -1);
						min-width: var(--px-150);
						text-align: right;
					}
				}
			}
		}
		&.tickSliderWrapper_4 {
			.tickSliderWrapper {
				.tickSliderLegendValue {
					min-width: var(--px-120);
				}
				&:last-child {
					.tickSliderLegend {
						margin-left: var(--px-168);
					}
					.tickSliderLegendValue {
						left: calc(var(--px-40) * -1);;
					}
				}
			}
		}
		&.tickSliderWrapper_5 {
			.tickSliderWrapper {
				.tickSliderLegendValue {
					min-width: var(--px-90);
				}
				&:last-child {
					.tickSliderLegend {
						margin-left: var(--px-110);
					}
					.tickSliderLegendValue {
						left: calc(var(--px-10) * -1);
					}
				}
			}
		}
	}
`;

const TicksWrapper = styled.section`
	position: relative;
	display: inline-flex;
	justify-content: center;
	margin-right: var(--px-5);
	.tickSliderLegendValue {
		display: flex;
		margin: var(--px-10) 0 0 0;
		width: 100%;
		line-height: normal;
		justify-content: center;
		.ellipses-multilines {
			width: auto;
			position: absolute;
		}
	}
	&:first-child {
		justify-content: flex-start;
		.tickSliderLegend {
			margin: calc(var(--px-4) * -1) 0 0 0;
			border-top: var(--px-5) solid transparent;
			border-bottom: var(--px-5) solid transparent;
			border-right: var(--px-12) solid var(--neutrals-700);
			width: 0;
			height: 0;
			z-index: 100;
		}
		.tickSliderLegendValue {
			margin-left: calc(var(--px-10) * -1);
			justify-content: flex-start;
		}
	}
	&:last-child {
		.tickSliderLegend {
			margin: calc(var(--px-4) * -1) calc(var(--px-85) * -1) 0 var(--px-80);
			border-top: var(--px-5) solid transparent;
			border-bottom: var(--px-5) solid transparent;
			border-left: var(--px-12) solid var(--neutrals-700);
			width: 0;
			height: 0;
			z-index: 100;
		}
		.tickSliderLegendValue {
			justify-content: flex-end;
			position: relative;
			text-align: right;
		}
	}
`;
